export default {
  description: 'Acompanhe as oportunidades comerciais nos Boards da sua empresa.',
  title: 'Oportunidades',
};
